import React__default from 'react';
import { toast } from '../../../node_modules/sonner/dist/index.esm.js';
import AddProposal from '../components/AddProposal.esm.js';
import ProposalListItem from '../components/ProposalListItem.esm.js';
import Button from '../../button/Button.esm.js';
import { useProposalContext } from '../proposalContext.esm.js';
import { handleAddOfferToProposal } from '../proposalService.esm.js';
import t from '../../../services/translatorService.esm.js';

const SelectProposal = ({
  offerData,
  source
}) => {
  const {
    state,
    dispatch,
    closeProposal
  } = useProposalContext();
  const {
    proposals
  } = state;
  const onConfirmClick = async () => {
    if (!state.selectedProposal) return;
    const activeProposal = proposals.find(proposal => proposal.id === state.selectedProposal);
    await handleAddOfferToProposal(state.selectedProposal, offerData, source, activeProposal);
    closeProposal();
    toast(t('proposals.addOfferSuccessNotification'), {
      className: 'voyage-toast',
      description: activeProposal?.name,
      duration: 5000,
      icon: /*#__PURE__*/React__default.createElement("i", {
        className: "ri-check-line text-lg text-primary"
      }),
      position: 'bottom-center',
      cancel: /*#__PURE__*/React__default.createElement("div", {
        className: "voyage-toast-close cursor-pointer",
        onClick: () => toast.dismiss()
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "ri-close-line text-lg"
      }))
    });
  };
  const onProposalClick = id => {
    if (state.selectedProposal === id) {
      dispatch({
        type: 'SET_SELECTED_PROPOSAL',
        payload: null
      });
    } else {
      dispatch({
        type: 'SET_SELECTED_PROPOSAL',
        payload: id
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "text-xl font-semibold mb-6 text-start"
  }, t('proposals.modalTitle')), /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col gap-2 mb-7 overflow-y-auto"
  }, /*#__PURE__*/React__default.createElement(AddProposal, null), proposals.map(proposal => (/*#__PURE__*/React__default.createElement(ProposalListItem, {
    data: proposal,
    onClick: onProposalClick,
    active: state.selectedProposal === proposal.id || proposal.offerIds.includes(offerData.offerId)
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "flex justify-between mt-auto"
  }, /*#__PURE__*/React__default.createElement(Button, {
    label: t('proposals.close'),
    variant: "secondary",
    size: "large",
    onClick: closeProposal,
    rounded: true
  }), /*#__PURE__*/React__default.createElement(Button, {
    label: t('proposals.confirm'),
    size: "large",
    onClick: onConfirmClick,
    disabled: !state.selectedProposal,
    rounded: true
  })));
};

export { SelectProposal as default };
//# sourceMappingURL=SelectProposal.esm.js.map
